export default __webpack_public_path__ + "static/media/01AW2SEP66.ff1b0dbb.jpg";